module.exports = __webpack_public_path__ + "img/thumb_19.b7d57972.png";